import { ContextMenu, DialogContextMenuItem } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { UserIndexResource } from "../shared/types";

interface Props {
	user: UserIndexResource;
	onBlock: () => void;
	onUnblock: () => void;
}

export const UserContextMenu: FC<Props> = ({ user, onBlock, onUnblock }) => {
	const { t } = useTranslation();

	return (
		<ContextMenu size="small" displayShortcutsAs="icon">
			{!user.isBlocked && (
				<DialogContextMenuItem
					label={t("Block user")}
					title={t("Block user")}
					heading={t("Block user")}
					labels={{ close: t("Close"), confirm: t("Confirm") }}
					action={onBlock}
				>
					{t("Are you sure you want to block this user?")}
				</DialogContextMenuItem>
			)}
			{user.isBlocked && (
				<DialogContextMenuItem
					label={t("Unblock user")}
					title={t("Unblock user")}
					heading={t("Unblock user")}
					labels={{ close: t("Close"), confirm: t("Confirm") }}
					action={onUnblock}
				>
					{t("Are you sure you want to unblock this user?")}
				</DialogContextMenuItem>
			)}
		</ContextMenu>
	);
};
